import { useEffect } from "react";

import { useIntl } from "react-intl";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "src/contentful";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import { BannerProps } from "@/components/wpl/banner-alert/src/banner-alert";
import { useLocalizedHref } from "@/libraries/web-framework";
import { getBannerConfig } from "@/templates/paid-landing/utils/itsm-jsm-banner-alert";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePagePaidLpJsmAnchor } from "./paid-lp-jsm-anchor";

export interface JiraSoftwarePagePaidLpJsmIncidentchangemgmtProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
    bannerAlertProps?: BannerProps;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const JiraServiceManagementSoftwarePagePaidLpJsmIncidentchangemgmtRelay =
    (pageProps: JiraSoftwarePagePaidLpJsmIncidentchangemgmtProps) => {
        const intl = useIntl();
        const linkUrl = useLocalizedHref(
            "/software/jira/service-management/comparison"
        );
        const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
            useExperimentExposure(experiments.cpapiDeprecationJsmExperiment);

        useEffect(() => {
            if (!cpapiDeprecationExposureFired) {
                fireCpapiDeprecationExposure();
            }
        }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);

        const data = usePreloadedQuery(
            AnchorPageRelayQuery,
            pageProps.queryRef ||
                (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
        );
        pageProps = Object.assign({}, pageProps, {
            bannerAlertProps: getBannerConfig({
                intl,
                linkUrl
            })
        });

        return (
            <JiraSoftwarePagePaidLpJsmAnchor
                {...pageProps}
                anchorContents={shapeAnchorContentfulResponse(data)}
                pageId="paid-lp-jsm-incidentchangemgmt"
                persona="unknown"
                pageVariant="incidentchangemgmt"
            />
        );
    };
